<template>
    <div class="table-column-filter">
        <!--------------------------------------------------------------------->
        <div ref="container" v-if="filter_method === 'modal'">
            <span class="relative" data-toggle="modal" :data-target="'#' + id" style="cursor:pointer">
                <span class="item-label">
                    {{ label }}
                </span>
                <span class="action-icons" v-if="allUniqueItems.length > 1 || (server_paginated && (filter_values.length > 0 || filterable))">
                    <template v-if="sortable">
                        <i class="fa" :class="icon+'-'+current_sort_direction" v-if="current_sort_direction"></i>
                        <i class="fa fa-caret-down" :class="{ invisible: !showDropDown }" v-else></i>
                    </template>
                    <i class="fa fa-filter" :class="hideFilterIcon ? 'invisible' : 'filter-active'" v-if="filterable"></i>
                </span>
            </span>

            <!-- MODAL -->
            <div :id="id" class="modal fade" role="dialog" tabindex="-1" ref="modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <i class="fa fa-close close" data-dismiss="modal"></i>
                            <h4 class="modal-title">{{ label }}</h4>
                        </div>
                        <div class="modal-body">
                            <ul class="column-filter-list" v-if="allUniqueItems.length > 1 || (server_paginated && (filter_values.length > 0 || filterable))" v-show="showDropDown">
                                <li v-if="sortable" class="text-bold">
                                    Sort
                                </li>
                                <li v-if="sortable">
                                    <div class="row m-0">
                                        <div class="col-xs-12 col-sm-6 p-t-5 p-b-5 cursor-pointer tcf-sort-option" @click="sortRowsAsc()">
                                            <i class="fa" :class="icon+'-asc'"></i>
                                            Sort Ascending
                                        </div>
                                        <div class="col-xs-12 col-sm-6 p-t-5 p-b-5 cursor-pointer tcf-sort-option" @click="sortRowsDesc()">
                                            <i class="fa" :class="icon+'-desc'"></i>
                                            Sort Descending
                                        </div>
                                    </div>
                                </li>
                                <li v-if="is_filterable" class="text-bold m-t-10">
                                    Filter
                                </li>
                                <li :class="{ 'disabled-option': hideFilterIcon }" @click.stop="clearColumnFilters" v-if="is_filterable">
                                    <a href="#">
                                        <i class="fa fa-ban"></i>
                                        Clear Filter From "{{ label }}"
                                    </a>
                                </li>
                                <template v-if="is_filterable">
                                    <template v-if="sort_method === 'numeric' && false">
                                        <hr class="m-t-5 m-b-15" />
                                        <transition-group name="fade" tag="ul" class="number-comparison-filters m-b-15">
                                            <li v-for="(item) in activeComparisons">
                                                <div class="row m-0 p-b-5">
                                                    <div class="col-xs-2">
                                                        <select class="form-control" v-model="item.logic">
                                                            <option value="AND">AND</option>
                                                            <option value="OR">OR</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-xs-5">
                                                        <select class="form-control" v-model="item.operator">
                                                            <option value="==">Equal To</option>
                                                            <option value="!=">Not Equal To</option>
                                                            <option value=">">Greater Than</option>
                                                            <option value=">=">Greater Than or Equal To</option>
                                                            <option value="<">Less Than</option>
                                                            <option value="<=">Less Than or Equal To</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-xs-5">
                                                        <input type="number" class="form-control" v-model="item.value" />
                                                    </div>
                                                </div>
                                            </li>
                                        </transition-group>
                                    </template>
                                    <hr class="m-t-5 m-b-15" />
                                    <li v-if="is_filterable" v-cloak>
                                        <a class="p-l-0" href="#">
                                            <input type="text" class="form-control" v-model="filter" ref="filter_input" placeholder="Search" />
                                            <span v-if="server_paginated" class="help-block m-t-5 m-b-0" style="font-size:11px">
                                                {{ searchHelpText }}
                                            </span>
                                        </a>
                                    </li>
                                </template>
                                <ul class="items-list" v-if="is_filterable" v-cloak>
                                    <li v-for="item in selectedItems" v-if="!server_paginated && uniqueItems.indexOf(item) == -1" v-cloak>
                                        <a href="#" @click.stop="toggleSelected(item)">
                                            <i class="fa" :class="selectedItems.indexOf(item) != -1 && removedFilters.indexOf(item) == -1 ? 'fa-check-square-o' : 'fa-square-o'"></i>
                                            {{ item }}
                                        </a>
                                    </li>
                                    <template v-if="server_paginated">
                                        <li v-for="item in serverFilteredItems" v-cloak>
                                            <a href="#" @click.stop="toggleSelected(item)">
                                                <i class="fa" :class="(selectedItems.indexOf(item) != -1 && removedFilters.indexOf(item) == -1) || newFilters.indexOf(item) != -1 ? 'fa-check-square-o' : 'fa-square-o'"></i>
                                                {{ item }}
                                            </a>
                                        </li>
                                    </template>
                                    <template v-else>
                                        <li v-for="item in uniqueItems" v-if="item && filter == ''" v-cloak>
                                            <a href="#" @click.stop="toggleSelected(item)">
                                                <i class="fa fa-square-o" v-if="(selectedItems.indexOf(item) == -1 && newFilters.indexOf(item) == -1 && removedFilters) || removedFilters.indexOf(item) != -1"></i>
                                                <i class="fa fa-check-square-o" v-else></i>
                                                {{ item }}
                                            </a>
                                        </li>
                                        <li v-for="item in matchingFilteredItems" v-if="filter != ''" v-cloak>
                                            <a href="#" @click.stop="toggleSelected(item)">
                                                <i class="fa fa-square-o" v-if="(selectedItems.indexOf(item) == -1 && newFilters.indexOf(item) == -1 && removedFilters) || removedFilters.indexOf(item) != -1"></i>
                                                <i class="fa fa-check-square-o" v-else></i>
                                                {{ item }}
                                            </a>
                                        </li>
                                    </template>
                                </ul>
                            </ul>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">
                                <i class="fa fa-times"></i>
                                Cancel
                            </button>
                            <button type="button" class="btn btn-sm btn-primary" :disabled="newFilters.length == 0 && removedFilters.length == 0 && completeActiveComparisons.length == 0 && !hasTypedValue" @click="applyFilters">
                                <i class="fa fa-check"></i>
                                Apply
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--------------------------------------------------------------------->
        <div ref="container" v-else-if="filter_method === 'date'">
            <span class="relative" data-toggle="modal" :data-target="'#' + id" style="cursor:pointer">
                <span class="item-label">{{ label }}</span>
                <span class="action-icons">
                    <template v-if="sortable">
                        <i class="fa" :class="icon+'-'+current_sort_direction" v-if="current_sort_direction"></i>
                        <i class="fa fa-caret-down" v-else></i>
                    </template>
                    <i class="fa fa-filter" :class="{ invisible: hideFilterIcon, 'filter-active': !hideFilterIcon }" v-if="filterable"></i>
                </span>
            </span>

            <div :id="id" class="modal fade" role="dialog" tabindex="-1" ref="modal">
                <div class="modal-dialog modal-sm" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <i class="fa fa-close close" data-dismiss="modal"></i>
                            <h4 class="modal-title">{{ label }}</h4>
                        </div>
                        <div class="modal-body">
                            <ul class="column-filter-list">
                                <li v-if="sortable" class="text-bold">Sort</li>
                                <li v-if="sortable">
                                    <div class="row m-0">
                                        <div class="col-xs-12 col-sm-6 p-t-5 p-b-5 cursor-pointer tcf-sort-option" @click="sortRowsAsc()">
                                            <i class="fa" :class="icon+'-asc'"></i> Sort Ascending
                                        </div>
                                        <div class="col-xs-12 col-sm-6 p-t-5 p-b-5 cursor-pointer tcf-sort-option" @click="sortRowsDesc()">
                                            <i class="fa" :class="icon+'-desc'"></i> Sort Descending
                                        </div>
                                    </div>
                                </li>
                                <li v-if="filterable" class="text-bold m-t-10">Filter</li>
                                <li v-if="filterable" :class="{ 'disabled-option': hideFilterIcon }" @click.stop="clearColumnFilters">
                                    <a href="#">
                                        <i class="fa fa-ban"></i>
                                        Clear Filter From "{{ label }}"
                                    </a>
                                </li>
                                <li v-if="filterable">
                                    <a href="#" class="no-hover">
                                        <input type="date" class="form-control" v-model="selectedDate"
                                            :min="date_min || ''" :max="date_max || ''" />
                                    </a>
                                    <div v-if="selectedItems.length > 0" class="p-l-17 m-b-5" style="font-size:11px;color:#777">
                                        Active: {{ selectedItems[0] }}
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">
                                <i class="fa fa-times"></i> Cancel
                            </button>
                            <button type="button" class="btn btn-sm btn-primary"
                                :disabled="!selectedDate"
                                @click="applyDateFilter">
                                <i class="fa fa-check"></i> Apply
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--------------------------------------------------------------------->
        <div class="dropdown" ref="container" v-else>
            <span class="dropdown-toggle relative" :id="id" data-toggle="dropdown">
                <span class="item-label">
                    {{ label }}
                </span>
                <span class="action-icons" v-if="allUniqueItems.length > 0 || (server_paginated && (filter_values.length > 0 || hasActiveLikeFilter || filterable))">
                    <template v-if="sortable">
                        <i class="fa" :class="icon+'-'+current_sort_direction" v-if="current_sort_direction"></i>
                        <i class="fa fa-caret-down" :class="{ invisible: !showDropDown }" v-else></i>
                    </template>
                    <i class="fa fa-filter" :class="hideFilterIcon ? 'invisible' : 'filter-active'" v-if="filterable"></i>
                </span>
            </span>
            <ul class="dropdown-menu scrollable-menu column-filter-list" :aria-labelledby="id" v-if="allUniqueItems.length > 0 || (server_paginated && (filter_values.length > 0 || hasActiveLikeFilter || filterable))" v-show="showDropDown">
                <li v-if="sortable" @click="sortRowsAsc()" v-cloak>
                    <a href="#">
                        <i class="fa" :class="icon+'-asc'"></i>
                        Sort Ascending
                    </a>
                </li>
                <li v-if="sortable" @click="sortRowsDesc()" v-cloak>
                    <a href="#">
                        <i class="fa" :class="icon+'-desc'"></i>
                        Sort Descending
                    </a>
                </li>
                <li :class="{ 'disabled-option': hideFilterIcon }" @click.stop="clearColumnFilters" v-if="is_filterable">
                    <a href="#">
                        <i class="fa fa-ban"></i>
                        Clear Filter From "{{ label }}"
                    </a>
                </li>
                <li v-if="is_filterable" v-cloak role="separator" class="divider"></li>
                <li v-if="is_filterable" v-cloak>
                    <a href="#">
                        <input type="text" class="form-control" v-model="filter" ref="filter_input" placeholder="Search" />
                        <span v-if="server_paginated" class="help-block m-t-5 m-b-0" style="font-size:11px">
                            {{ searchHelpText }}
                        </span>
                    </a>
                </li>
                <ul class="items-list" v-if="is_filterable" v-cloak>
                    <li v-for="item in selectedItems" v-if="!server_paginated && uniqueItems.indexOf(item) == -1" v-cloak>
                        <a href="#" @click.stop="toggleSelected(item)">
                            <i class="fa" :class="selectedItems.indexOf(item) != -1 && removedFilters.indexOf(item) == -1 ? 'fa-check-square-o' : 'fa-square-o'"></i>
                            {{ item }}
                        </a>
                    </li>
                    <template v-if="server_paginated">
                        <li v-for="item in serverFilteredItems" v-cloak>
                            <a href="#" @click.stop="toggleSelected(item)">
                                <i class="fa" :class="(selectedItems.indexOf(item) != -1 && removedFilters.indexOf(item) == -1) || newFilters.indexOf(item) != -1 ? 'fa-check-square-o' : 'fa-square-o'"></i>
                                {{ item }}
                            </a>
                        </li>
                    </template>
                    <template v-else>
                        <li v-for="item in uniqueItems" v-if="item && filter == ''" v-cloak>
                            <a href="#" @click.stop="toggleSelected(item)">
                                <i class="fa fa-square-o" v-if="(selectedItems.indexOf(item) == -1 && newFilters.indexOf(item) == -1 && removedFilters) || removedFilters.indexOf(item) != -1"></i>
                                <i class="fa fa-check-square-o" v-else></i>
                                {{ item }}
                            </a>
                        </li>
                        <li v-for="item in matchingFilteredItems" v-if="filter != ''" v-cloak>
                            <a href="#" @click.stop="toggleSelected(item)">
                                <i class="fa fa-square-o" v-if="(selectedItems.indexOf(item) == -1 && newFilters.indexOf(item) == -1 && removedFilters) || removedFilters.indexOf(item) != -1"></i>
                                <i class="fa fa-check-square-o" v-else></i>
                                {{ item }}
                            </a>
                        </li>
                    </template>
                </ul>

                <div class="dropdown-buttons p-5 text-right" v-if="is_filterable">
                    <button type="button" class="btn btn-sm btn-secondary">
                        <i class="fa fa-times"></i>
                        Cancel
                    </button>
                    <button type="button" class="btn btn-sm btn-primary" :disabled="newFilters.length == 0 && removedFilters.length == 0 && completeActiveComparisons.length == 0 && !hasTypedValue" @click="applyFilters">
                        <i class="fa fa-check"></i>
                        Apply
                    </button>
                </div>
            </ul>
        </div>
    </div>
</template>

<style lang="scss" scoped>

    @import '../../sass/_global_variables.scss';

    $text-color: #4c4c4c;

    .modal-body .column-filter-list {
        > li {
            padding-left: 15px;
        }

        .tcf-sort-option:hover,
        .tcf-sort-option:focus {
            color: darken($text-color, 10%);
            background-color: rgba(0, 0, 0, 0.075);
        }

    }

    .table-column-filter {

        .relative {
            position: relative;
        }

        .item-label {
            display: inline-block;
            padding-right: 35px;
        }

        .action-icons {
            white-space: nowrap;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);

            .fa-filter {
                zoom: 1.25;
                color: lighten($gray-blue, 25%);

                &.filter-active {
                    color: #26A2D9;
                }
            }
        }
    }

    .column-filter-list,
    .number-comparison-filters {
        padding: 0;
        list-style-type: none;

        li {
            text-align: left;

            > a {
                display: inline-block;
                width: 100%;
                padding: 8px 17px;
                color: $text-color;
                font-weight: normal;
            }

            > a.no-hover:hover,
            > a.no-hover:focus {
                color: darken($text-color, 10%);
                background-color: transparent;
            }

            > a.no-bottom-padding {
                padding-bottom: 0;
            }

            i.fa {
                color: $text-color !important;
            }

            &.form-control {
                text-align: left;
            }

            &.disabled-option a {
                color: lighten($text-color, 50%) !important;

                i {
                    color: lighten($text-color, 50%) !important;
                }
            }
        }

        ul.items-list {
            height: auto;
            max-height: 150px;
            overflow-y: auto;
            padding: 0;

            li > a {
                display: block;
                clear: both;
                font-weight: normal;
                padding: 8px 17px;
                color: $text-color;

                i.fa {
                    color: $text-color !important;
                    width: 13px;
                    margin-right: 5px;
                }
            }

            li > a:hover,
            li > a:focus {
                color: darken($text-color, 10%);
                background-color: rgba(0, 0, 0, 0.075);
            }
        }
    }
</style>

<script>
    export default{
        props: {
            column_name: { default: null },
            label: { default: "" },
            sortable: { default: true },
            filterable: { default: true },
            filter_method: { default: 'dropdown' },
            sort_method: { default: 'string' },
            rows: { default () { return [] }},
            active_sort: { default: null },
            active_filters: { default() { return {} }},
            comparison_filters: { default () { return {} }},
            visible_rows: { default() { return [] }},
            server_paginated: { type: Boolean, default: false },
            filter_values: { default() { return [] } },
            active_like_filters: { default() { return {} } },
            date_min: { default: null },
            date_max: { default: null },
        },

        data: function() {
            return {
                container: $(),
                modal: $(),
                filter: "",
                newFilters: [],
                removedFilters: [],
                activeComparisons: [{ logic: 'IS', operator: '==', value: '' }],
                selectedDate: '',
            }
        },

        computed: {
            hasActiveLikeFilter () {
                return _.has(this.active_like_filters, this.column_name) && this.active_like_filters[this.column_name] !== '';
            },

            hideFilterIcon () {
                return !this.hasActiveLikeFilter &&
                    this.selectedItems.length === 0 &&
                    (!_.has(this.comparison_filters,this.column_name) || this.comparison_filters[this.column_name].length === 0);
            },

            completeActiveComparisons () {
                return this.activeComparisons.filter(item => item.value);
            },

            current_sort_direction () {
                if (!_.has(this.active_sort, 'column') || this.active_sort.column !== this.column_name) return null;
                var dir = this.active_sort.direction;
                return dir ? dir.toLowerCase() : null;
            },

            showDropDown () {
                return this.uniqueItems.length > 1 || this.selectedItems.length > 0 || !this.hideFilterIcon || (this.server_paginated && (this.filter_values.length > 0 || this.filterable));
            },

            is_filterable () {
                return this.filterable &&
                    (this.server_paginated || this.filter !== '' || this.uniqueItems.length > 1 || this.selectedItems.length > 0 || !this.hideFilterIcon);
            },

            id: function() {
                return "table-colum-filter-" + this.column_name + "-" + Math.floor(Math.random() * 10000);
            },

            icon: function() {
                switch (this.sort_method) {
                    case "numeric":
                    case "date":
                    case "mwl_report":
                        return "fa-sort-numeric";
                    default:
                        return "fa-sort-alpha";
                }
            },

            selectedItems () {
                return _.has(this.active_filters,this.column_name) ? this.active_filters[this.column_name] : [];
            },

            activeComparisonFilters () {
                return _.has(this.comparison_filters,this.column_name) ? this.comparison_filters[this.column_name] : [];
            },

            uniqueItems () {
                return this.visible_rows.map(row => { return _.has(row,['data',this.column_name]) ? row.data[this.column_name] : '' })
                    .filter((item,index,array) => array.indexOf(item) === index)
                    .sort();
            },

            allUniqueItems () {
                return this.rows.map(row => { return _.has(row,['data',this.column_name]) ? row.data[this.column_name] : '' })
                    .filter((item,index,array) => array.indexOf(item) === index)
                    .sort();
            },

            matchingFilteredItems () {
                return this.allUniqueItems
                    .filter(item => item && item.toString().toLowerCase().includes(this.filter.toLowerCase()))
                    .sort();
            },

            serverFilteredItems () {
                if (!this.server_paginated) return [];
                const search = this.filter.toLowerCase();
                if (!search) return this.filter_values;
                return this.filter_values.filter(item =>
                    item && item.toString().toLowerCase().includes(search)
                );
            },

            searchMinLength () {
                return this.sort_method === 'numeric' ? 1 : 3; // numeric columns can be searched with fewer characters
            },

            searchHelpText () {
                return `Select from list, or type ${this.searchMinLength}+ characters to search all results`;
            },

            hasTypedValue () {
                return this.server_paginated && this.filter.length >= this.searchMinLength;
            },
        },

        watch: {
            activeComparisonFilters () {
                this.activeComparisons = this.activeComparisonFilters.slice();
            },

            activeComparisons: {
                deep: true,
                handler () {
                    if (this.activeComparisons.length < 3 && this.activeComparisons.filter(item => !item.value).length === 0) {
                        this.activeComparisons.push({logic: 'AND', operator: '==', value: ''});
                    }
                }
            }
        },

        methods: {
            toggleSelected (new_item) {
                if (this.server_paginated && this.filter.length > 0) {
                    this.filter = '';
                }

                let existing = this.selectedItems.find(item => item === new_item);

                if (existing) {
                    let removed = this.removedFilters.find(item => item === new_item);
                    if (removed) {
                        this.removedFilters.splice(this.removedFilters.indexOf(new_item), 1);
                    } else {
                        this.removedFilters.push(new_item);
                    }
                }
                else {
                    let added = this.newFilters.find(item => item === new_item);
                    if (added) {
                        this.newFilters.splice(this.newFilters.indexOf(new_item), 1);
                    } else {
                        this.newFilters.push(new_item);
                    }
                }
            },

            applyDateFilter () {
                if (this.selectedDate) {
                    this.$emit('apply_column_filters', {
                        column: this.column_name,
                        toAdd: [this.selectedDate],
                        toRemove: this.selectedItems.slice(),
                    });
                }
                this.hideModal();
            },

            applyFilters () {
                if (this.server_paginated && this.hasTypedValue && this.newFilters.length === 0) {
                    this.$emit('add_like_filter', {
                        column: this.column_name,
                        value: this.filter
                    });
                    this.filter = '';
                } else if (this.server_paginated) {
                    this.$emit('apply_column_filters', {
                        column: this.column_name,
                        toAdd: this.newFilters.slice(),
                        toRemove: this.removedFilters.slice(),
                    });
                } else {
                    this.newFilters.forEach(item => {
                        this.addFilter({ column: this.column_name, filter: item });
                    });
                    this.removedFilters.forEach(item => {
                        this.removeFilter({ column: this.column_name, filter: item });
                    });
                }

                this.updateComparisonFIlter();
                this.hideModal();

                this.newFilters = [];
                this.removedFilters = [];
            },

            hideModal () {
                if (typeof this.modal.modal === 'function') {
                    this.modal.modal('hide');
                }
            },

            sortRows (sort_info) {
                this.$emit('sort',sort_info);
                this.hideModal();
            },

            updateComparisonFIlter () {
                if (this.completeActiveComparisons.length > 0) {
                    this.$emit('comparison_filter', {
                        column: this.column_name,
                        comparisons: this.completeActiveComparisons
                    });
                }
            },

            addFilter (filter_info) {
                this.$emit('add_filter',filter_info);
            },
            
            removeFilter (filter_info) {
                this.$emit('remove_filter',filter_info);
            },
            
            sortRowsAsc: function() {
                this.sortRows({
                    column: this.column_name,
                    method: this.sort_method
                });
            },

            sortRowsDesc: function() {
                this.sortRows({
                    column: this.column_name,
                    descending: true,
                    method: this.sort_method
                });
            },

            clearColumnFilters () {
                this.$emit('clear_filters',this.column_name);
                this.hideModal();
            },

            addFilterMenuEventHandlers () {
                var vm = this;
                vm.container.on('hidden.bs.dropdown', () => {
                    vm.container.find('.dropdown-menu').removeClass('dropdown-menu-right');
                    vm.newFilters = [];
                    vm.removedFilters = [];
                    vm.filter = '';
                })
                .on('shown.bs.dropdown', () => {
                    var menu = vm.container.find('.dropdown-menu');
                    var rect = menu[0].getBoundingClientRect();
                    if (rect.right > (window.innerWidth || document.documentElement.clientWidth)) {
                        menu.addClass('dropdown-menu-right');
                    }
                    $(vm.$refs.filter_input).focus();
                });

                vm.modal.on('hidden.bs.modal', () => {
                    vm.newFilters = [];
                    vm.removedFilters = [];
                    vm.filter = '';
                }).on('shown.bs.modal', () => {
                    if (vm.filter_method === 'date') {
                        vm.selectedDate = vm.selectedItems[0] || '';
                    } else {
                        $(vm.$refs.filter_input).focus();
                    }
                });
            }
        },

        mounted: function() {
            this.container = $(this.$refs.container);
            this.modal = $(this.$refs.modal);

            // Move the modal to the body to avoid positioning issues
            $('body').append(this.modal.detach());
            
            Vue.nextTick(this.addFilterMenuEventHandlers);
        }
    }
</script>



// WEBPACK FOOTER //
// table-column-filter.vue?99704a06